import { useCallback } from 'react'
import { useAtomValue, useSetAtom } from 'jotai'
import { toast } from 'sonner'
import DOMPurify from 'dompurify'
import { useTar } from '@/modules'
import { currentSolutionAtom } from '@/store/saveWorkAtoms'
import { workspaceSolutionReviewVisibleAtom } from '@/store/workspaceAtoms'

const cleanSolution = (solution: string) => DOMPurify.sanitize(solution, { ALLOWED_TAGS: [] }).trim()

const defaultSolution = `<h2>Data Sanity</h2><div><i>(Write your checks — what's broken, what's missing, what's weird?)</i></div><div><br></div><h2>Exploration &amp; Hypotheses</h2><div><i>(What patterns or relationships are you looking for?)</i></div><div><br></div><h2>Main Analysis</h2><div><i>(Explain your reasoning — connect evidence to insights)</i></div><div><br></div><h2>Interpretation &amp; Conclusions</h2><div><i>(What would you recommend the stakeholder?)</i></div><div><br></div><h2>Next Steps / Limitations</h2><div><i>("If I had more data, I'd check…" / "This trend might be biased because…")</i></div>`
const cleanedDefaultSolution = cleanSolution(defaultSolution)

export const useSubmitToReview = () => {
  const { t } = useTar()
  const currentSolution = useAtomValue(currentSolutionAtom)
  const setIsSolutionReviewVisible = useSetAtom(workspaceSolutionReviewVisibleAtom)

  const handleSubmit = useCallback(() => {
    const cleanedSolution = cleanSolution(currentSolution.trim() || '')
    if (!cleanedSolution || cleanedSolution === cleanedDefaultSolution) {
      toast.error(t('challenges.noSolutionProvidedYet'))
      return
    }
    if (cleanedSolution.length < 50) {
      toast.error(t('challenges.solutionTooShortForMeaningfulFeedback'))
      return
    }
    setIsSolutionReviewVisible(true)
  }, [currentSolution, t, setIsSolutionReviewVisible])

  return { handleSubmit }
}
